import React from 'react'
import { tagAxisIds, TagAxis } from '@cpsy-rmap-project/tags'
import { DetailedPaper } from '@cpsy-rmap-project/web-core/repositories'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import _ from 'lodash'
import Pill from '../../atoms/Pill'
import { useSubmitModelDialog } from '../../molecules/SubmitModelDialog/hooks'
import { varidateKeywords } from '../../molecules/SubmitModelDialog/varidation'

interface Props {
  papers: DetailedPaper[]
  filteringPapers: DetailedPaper[]
  freewords: string
  filterTagsV2: Partial<Record<TagAxis['id'], string[]>>
  excludeTagsV2: Partial<Record<TagAxis['id'], string[]>>
  selectHeatMapCellTags?: string[]
  enableAddPaperInfo?: boolean
  handleReset: () => void
}

const Component: React.FC<Props> = ({
  papers,
  filteringPapers,
  freewords,
  filterTagsV2,
  excludeTagsV2,
  selectHeatMapCellTags,
  enableAddPaperInfo,
  handleReset
}) => {
  const filterTagIds = _.flatten(_.compact(tagAxisIds.map(tagAxisId => filterTagsV2[tagAxisId])))
  const excludeTagIds = _.flatten(_.compact(tagAxisIds.map(tagAxisId => excludeTagsV2[tagAxisId])))
  const selectHeatMapCellTagIds = selectHeatMapCellTags ?? []

  // 重複削除
  const allFilterTagIds = _.uniq([...filterTagIds, ...selectHeatMapCellTagIds])

  // 論文登録へ
  const { handle } = useSubmitModelDialog()
  const openSubmitModelDialog = (keywords?: string) => {
    handle.handleResetState()
    handle.handleOpenWithKeywords(keywords)
  }
  const isFreewordsUseInSubmitKeywords = !_.isEmpty(freewords) && _.isEmpty(varidateKeywords(freewords))

  return (
    <>
      {!_.isEmpty(freewords) && <Typography variant="body2">{`- Filter by [${freewords}]`}</Typography>}
      {!_.isEmpty(allFilterTagIds) && (
        <Typography variant="body2">
          - Filter tags{' '}
          {allFilterTagIds.map(tagId => (
            <Pill key={tagId} id={tagId} />
          ))}
        </Typography>
      )}
      {!_.isEmpty(excludeTagIds) && (
        <Typography variant="body2">
          - Exclude tags{' '}
          {excludeTagIds.map(tagId => (
            <Pill key={tagId} id={tagId} />
          ))}
        </Typography>
      )}
      <Typography variant="body2">
        {`- ${papers.length} papers`}
        {papers.length !== filteringPapers.length && ` -> filtering to ${filteringPapers.length} papers`}
      </Typography>

      {!_.isEmpty(freewords) ||
        (!_.isEmpty(allFilterTagIds) && (
          <Box style={{ margin: '10px 0' }}>
            <Button
              variant="outlined"
              color="default"
              size="small"
              onClick={() => {
                handleReset()
              }}
            >
              Reset All
            </Button>
          </Box>
        ))}

      {enableAddPaperInfo && (
        <Box style={{ margin: '10px 0' }}>
          <Typography variant="body2" color="primary" style={{ marginLeft: '10px' }}>
            If you cannot find the paper you are looking for, please help us by adding it to the database.
            <Link
              style={{ marginLeft: '10px' }}
              onClick={() => {
                isFreewordsUseInSubmitKeywords ? openSubmitModelDialog(freewords) : openSubmitModelDialog()
              }}
            >
              <Button variant="contained" size="small" color="primary">
                Add new CPSY paper
                {/* {isFreewordsUseInSubmitKeywords &&
                  ` with search keyword [${freewords}]`} */}
              </Button>
            </Link>
          </Typography>
        </Box>
      )}
    </>
  )
}
export default Component
